<!--
  Unfortunately, this template seems to have unnecessary duplication, but there are reasons for it.

  1. <mat-select>'s [multiple] input doesn't support dynamic changes, so we're forced to have two copies of <mat-select>, one for multiselect,
     and one for single select.

  2. It seems like we should be able to have a single <mx-base-form-field> element that contains two <mat-select> elements in an @if/@else.
     but that causes the classic "mat-form-field must contain a MatFormFieldControl" error message.  The @if turns it into a content projection issue,
     and Angular doesn't have adequate support for that.  Thus, we need to move that @if up a level and have two copies of the base element.

  3. It seems like we should be able to create a reusable <ng-template> for the <mat-option> values, but that causes a similar content projection issue.
     So that element list is blatantly copied and pasted.
-->

@if (multiple) {
  <mx-base-form-field [fieldName]="fieldName" [overrideLabel]="overrideLabel" [formGroup]="formGroup" [control]="control" [enabled]="enabled"
                      [hintLabel]="hintLabel">
    <mat-select [multiple]="true" [formControl]="control" [panelClass]="optionsPanelClass" [disableOptionCentering]="true" [compareWith]="compareWith">
      <mat-select-trigger>
        {{ triggerLabel }}
      </mat-select-trigger>

      @if (includeSelectAllOption) {
        <mat-option #selectAllOption (click)="toggleAll()"> {{ selectAllLabel }}</mat-option>
        <mat-divider/>
      }

      @for (option of options; track hasDuplicateOptionValues ? $index : option.value) {
        <mat-option [value]="option.value" [disabled]="isDisabled(option)">
          <span [matTooltip]="disabledOptionTooltipFor(option)" class="block w-full">{{ option.displayName }}</span>
        </mat-option>
      }
    </mat-select>
  </mx-base-form-field>
} @else {
  <mx-base-form-field [fieldName]="fieldName" [overrideLabel]="overrideLabel" [formGroup]="formGroup" [control]="control" [enabled]="enabled"
                      [hintLabel]="hintLabel">
    <mat-select [formControl]="control" [panelClass]="optionsPanelClass" [disableOptionCentering]="true" [compareWith]="compareWith">
      @if (includeUndefinedOption) {
        <mat-option [value]="undefined"/>
      }

      @for (option of options; track hasDuplicateOptionValues ? $index : option.value) {
        <mat-option [value]="option.value" [disabled]="isDisabled(option)">
          <span [matTooltip]="disabledOptionTooltipFor(option)" class="block w-full">{{ option.displayName }}</span>
        </mat-option>
      }
    </mat-select>
  </mx-base-form-field>
}
